// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.comments {
  margin: 25px 0 15px 0;
}
.comments__header {
  cursor: pointer;
  width: auto;
}
.comments__header p {
  width: auto !important;
}
.comments__body {
  display: flex;
  flex-direction: column;
  width: 100%;
  box-shadow: rgba(9, 30, 66, 0.25) 0px 1px 1px, rgba(9, 30, 66, 0.13) 0px 0px 1px 1px;
  padding: 10px;
  border-radius: 5px;
  max-height: 505px;
  overflow-y: auto;
}
.comments__body--message {
  min-width: 500px;
  background-color: rgba(0, 0, 0, 0.0588235294);
  padding: 6px 8px 8px 9px;
  border-radius: 5px;
  margin: 2px 0;
}
@media (max-width: 768px) {
  .comments__body--message {
    width: 100% !important;
  }
}
.comments__body--message__user {
  display: flex;
}
.comments__body--message__user p {
  margin: 0 0 0 5px;
  font-size: 0.9rem;
  font-weight: 700 !important;
}
.comments__body--message__comment p {
  margin: 1px 0 0 30px;
  font-size: 14.2px;
}
.comments__body--message__comment p p {
  margin: 0;
}
.comments__body--message__time {
  display: flex;
  justify-content: flex-end;
}
.comments__body--message__time p {
  margin: 0;
  font-size: 11px;
}
.comments__body--message__attachment--item {
  display: flex;
  align-items: center;
  margin: 5px 0 0 30px;
}
.comments__body--message__attachment--item p {
  margin: 0;
  font-size: 0.8rem;
}
.comments__body--message__attachment--item input {
  margin: 0 0 0 5px;
}
.comments__body--message__attachment--item:nth-child(1) {
  width: auto;
  padding: 5px;
  border: 1px solid blue;
  cursor: pointer;
  color: blue;
}
.comments__body--mine {
  align-self: flex-end;
}
.comments__body--recevier {
  align-self: flex-start;
}
.comments__body--no-comments {
  text-align: center;
  margin: 10px 0;
}
.comments__body::-webkit-scrollbar-thumb {
  background-color: #aca9a9;
  border-radius: 10px;
}
.comments__body::-webkit-scrollbar-track {
  background-color: #f0f0f0;
  border-radius: 10px;
}
.comments__body::-webkit-scrollbar {
  width: 10px;
}

#tax-file {
  margin-left: 10px;
}`, "",{"version":3,"sources":["webpack://./src/components/Comments/styles.scss","webpack://./src/utils/styles/global.scss"],"names":[],"mappings":"AAEA;EACI,qBAAA;AADJ;AAGI;EACI,eAAA;EACA,WAAA;AADR;AAEQ;EACI,sBAAA;AAAZ;AAII;EACI,aAAA;EACA,sBAAA;EACA,WAAA;EACA,oFAAA;EACA,aAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;AAFR;AAIQ;EACI,gBAAA;EACA,6CAAA;EACA,wBAAA;EACA,kBAAA;EACA,aAAA;AAFZ;AClBQ;EDeA;IAQQ,sBAAA;EADd;AACF;AAGY;EACI,aAAA;AADhB;AAEgB;EACI,iBAAA;EACA,iBAAA;EACA,2BAAA;AAApB;AAKgB;EACI,oBAAA;EACA,iBAAA;AAHpB;AAKoB;EACQ,SAAA;AAH5B;AAQY;EACI,aAAA;EACA,yBAAA;AANhB;AAOgB;EACI,SAAA;EACA,eAAA;AALpB;AAUgB;EACI,aAAA;EACA,mBAAA;EACA,oBAAA;AARpB;AAUoB;EACI,SAAA;EACA,iBAAA;AARxB;AAWoB;EACI,iBAAA;AATxB;AAagB;EACI,WAAA;EACA,YAAA;EACA,sBAAA;EACA,eAAA;EACA,WAAA;AAXpB;AAkBQ;EACI,oBAAA;AAhBZ;AAmBQ;EACI,sBAAA;AAjBZ;AAoBQ;EACI,kBAAA;EACA,cAAA;AAlBZ;AAsBI;EACI,yBAAA;EACA,mBAAA;AApBR;AAuBI;EACI,yBAAA;EACA,mBAAA;AArBR;AAwBI;EACI,WAAA;AAtBR;;AA0BA;EACI,iBAAA;AAvBJ","sourcesContent":["@import '../../utils/styles/global.scss';\n\n.comments{\n    margin: 25px 0 15px 0;\n\n    &__header{\n        cursor: pointer;\n        width: auto;\n        p{\n            width: auto !important;\n        }\n    }\n\n    &__body{\n        display: flex;\n        flex-direction: column;\n        width: 100%;\n        box-shadow: rgba(9, 30, 66, 0.25) 0px 1px 1px, rgba(9, 30, 66, 0.13) 0px 0px 1px 1px;\n        padding: 10px;\n        border-radius: 5px;\n        max-height: 505px;\n        overflow-y: auto;\n\n        &--message{\n            min-width: 500px;\n            background-color: #0000000f;\n            padding: 6px 8px 8px 9px;\n            border-radius: 5px;\n            margin: 2px 0;\n\n            @include breakpoint(md) {\n                width: 100% !important;\n            }\n\n            &__user{\n                display: flex;\n                p {\n                    margin: 0 0 0 5px;\n                    font-size: 0.9rem;\n                    font-weight: 700 !important;\n                }\n            }\n\n            &__comment{\n                p {\n                    margin: 1px 0 0 30px;\n                    font-size: 14.2px;\n\n                    p {\n                            margin: 0;\n                        }\n                }\n            }\n\n            &__time{\n                display: flex;\n                justify-content: flex-end;\n                p{\n                    margin: 0;\n                    font-size: 11px;\n                }\n            }\n\n            &__attachment{\n                &--item{\n                    display: flex;\n                    align-items: center;\n                    margin: 5px 0 0 30px;\n\n                    p{\n                        margin: 0;\n                        font-size: 0.8rem;\n                    }\n\n                    input{\n                        margin: 0 0 0 5px;\n                    }\n                }\n\n                &--item:nth-child(1){\n                    width: auto;\n                    padding: 5px;\n                    border: 1px solid blue;\n                    cursor: pointer;\n                    color: blue;\n                }\n            }\n        }\n\n               \n\n        &--mine{\n            align-self: flex-end;\n        }\n\n        &--recevier{\n            align-self: flex-start;\n        }\n\n        &--no-comments{\n            text-align: center;\n            margin: 10px 0;\n        }\n    }\n\n    &__body::-webkit-scrollbar-thumb {\n        background-color: #aca9a9;\n        border-radius: 10px;\n    }\n\n    &__body::-webkit-scrollbar-track {\n        background-color: #f0f0f0;\n        border-radius: 10px;\n    }\n\n    &__body::-webkit-scrollbar {\n        width: 10px;\n    }\n}\n\n#tax-file{\n    margin-left: 10px;\n}","@mixin breakpoint($point) {\n    @if $point == sm {\n        @media (max-width: 576px) {\n            @content;\n        }\n    }\n\n    @else if $point == md {\n        @media (max-width: 768px) {\n            @content;\n        }\n    }\n\n    @else if $point == lg {\n        @media (max-width: 992px) {\n            @content;\n        }\n    }\n\n    @else if $point == xl {\n        @media (max-width: 1200px) {\n            @content;\n        }\n    }\n\n    @else if $point == xxl {\n        @media (max-width: 1400px) {\n            @content;\n        }\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
